export class QPNConnectingLine {
  constructor() {
    this.fLeft = null;
    this.fRight = null;
    this.fTop = null;
    this.fBottom = null;
    this.fAssociatedLayouts = null;
  }

  InitLine(left, top, right, bottom) {
    this.fLeft = left;
    this.fRight = right;
    this.fTop = top;
    this.fBottom = bottom;
  }

  GetAssociatedLayouts() {
    return this.fAssociatedLayouts;
  }

  AssociateLayout(aLayout) {
    var index = this.IsLayoutAssociated(aLayout);
    if (index == -1) {
      if (this.fAssociatedLayouts == null) this.fAssociatedLayouts = new Array();
      this.fAssociatedLayouts.push(aLayout);
    }
  }

  IsLayoutAssociated(aLayout) {
    if (this.fAssociatedLayouts == null) return -1;

    return this.fAssociatedLayouts.indexOf(aLayout);
  }
}
